import styled from 'styled-components';

export const SideNavContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export const IntegrationsContainer = styled.div`
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	padding: 12px;
	gap: 12px;
	width: 100%;
`;

export const IntegrationCardContainer = styled.div`
	border: 1px solid rgba(228, 231, 236, 0.67);
	border-radius: 8px;
	padding: 3px;
	width: 100%;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
`;

export const StyledInputGroup = styled.div`
	margin-bottom: 12px;
	padding: 0px 12px 0px 12px;
	display: flex;
	flex-direction: column;
`;

export const StyledSelect = styled.select`
	width: 100%;
	padding: 7px;
	border-radius: 4px;
`;

export const StyledInput = styled.input`
	width: 100%;
	padding: 6px;
	border-radius: 4px;
	border: 1px solid black;
`;

export const Header = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 12px;
`;

export const HeaderTitle = styled.span`
	font-weight: bold;
`;

export const SideNavFooter = styled.div`
	border-top: 1px solid #e4e7ec;
	padding: 16px 12px;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 12px;
`;



